module.exports = __webpack_public_path__ + "static/media/shareresource.25642d03.svg";